module.exports = __webpack_public_path__ + "media/images/free-ticket-button@2x-4ea56c96a7bd793353c12c986cdf8193.png";